module.exports = __webpack_public_path__ + "img/two.e4cf412a.png";